Accounts = require 'common/lib/accounts'
Auth = require 'db/auth'
AccountTransferRequiredBannerView = undefined
queueRequire -> AccountTransferRequiredBannerView = require 'views/header/account-transfer-required-banner-view'
BoardsSidebarView = undefined
queueRequire -> BoardsSidebarView = require 'views/boards-sidebar/boards-sidebar-view'
Browser = require 'lib/browser'
BrowserWillBeUnsupportedView = undefined
queueRequire -> BrowserWillBeUnsupportedView = require 'views/header/browser-will-be-unsupported-view'
ConfirmEmailBannerView = undefined
queueRequire -> ConfirmEmailBannerView = require 'views/header/confirm-email-banner-view'
HeaderBackButtonView = undefined
queueRequire -> HeaderBackButtonView = require 'views/header/header-back-button-view'
EnterpriseLicenseBannerView = undefined
queueRequire -> EnterpriseLicenseBannerView = require 'views/header/enterprise-license-banner-view'
HeaderBoardsButtonView = undefined
queueRequire -> HeaderBoardsButtonView = require 'views/header/header-boards-button-view'
HeaderMemberView = undefined
queueRequire -> HeaderMemberView = require 'views/header/header-member-view'
HeaderWoofView = undefined
queueRequire -> HeaderWoofView = require 'views/header/header-woof-view'
InvitedBannerView = undefined
queueRequire -> InvitedBannerView = require 'views/header/invited-banner-view'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
NewLocaleBannerView = require 'views/header/new-locale-banner-view'
OverdueBannerView = undefined
queueRequire -> OverdueBannerView = require 'views/header/overdue-banner-view'
PostRender = require 'views/lib/post-render'
PublicBoardBannerView = undefined
queueRequire -> PublicBoardBannerView = require 'views/header/public-board-banner-view'
SearchInputView = undefined
queueRequire -> SearchInputView = require 'views/search/search-input-view'
SidebarState = undefined
queueRequire -> SidebarState = require 'view-models/sidebar-state'
SetPasswordBannerView = undefined
queueRequire -> SetPasswordBannerView = require 'views/header/set-password-banner-view'
track = require 'debug/track'
TwoFactorBackupsBannerView = undefined
queueRequire -> TwoFactorBackupsBannerView = require 'views/header/two-factor-backups-banner-view'
Util = require 'lib/util'
_ = require 'underscore'
$ = require 'jquery'
moment = require 'moment'
templates = require 'views/internal/templates'
locales = require('common/data/supported-locales').default
getExperiment = require 'lib/experiments/simple-test'


needBackupCodes = (member) ->
  twoFactorPrefs = member.getPref('twoFactor')
  twoFactorPrefs?.enabled && twoFactorPrefs.needsNewBackups

getOverdueOrganization = (member) ->
  bcOrgs = member.organizationList.filter (org) ->
    org.isPremium() &&
    org.ownedByMember(member) &&
    !org.paysWithPurchaseOrder()

  for bcOrg in bcOrgs
    paidAccount = bcOrg.get('paidAccount')
    billingDate = new Date(paidAccount.billingDates?[paidAccount.products?[0]])
    bannerName = "OverdueBanner-#{bcOrg.id}-#{billingDate.getTime()}"
    if Accounts.isProblem(paidAccount.standing) &&
        paidAccount.needsCreditCardUpdate &&
        !member.isDismissed(bannerName)
      return bcOrg

showSeatCapBanner = (member, headerCache, topLevelView) =>
  # get the enterprise this member is the admin of, if any
  return unless enterprise = _.find member.enterpriseList.models, (e) ->
    member.isEnterpriseAdminOf e

  # show the banner again the following month if they dismiss it
  return if not member.shouldShowEnterpriseBannerFor(enterprise)

  # load data for max members and available licenses asynchronously
  # and check if the banner should be shown once they have loaded
  enterprise.loadMaxMembers().then =>
    return unless maxMembers = enterprise.getPref('maxMembers')

    # only load the user types if max member is set
    enterprise.loadLicenses().then =>
      available = enterprise.getAvailableLicenses()
      threshold = Math.min(Math.ceil(maxMembers * 0.05), 20)
      if available <= threshold
        data = {
          enterprise
          seats: { max: maxMembers, available }
        }
        $('#header').after(topLevelView(EnterpriseLicenseBannerView, data, modelCache: headerCache).render().el)

        #record that the banner was shown for this user, so we don't show it again right away
        member.recordEnterpriseBannerShownFor(enterprise)

  return

module.exports =
  showHeader: (opts = {}) ->
    $('#header .header-user').remove()
    $('#header .header-boards-button').remove()
    $('#header #header-search').parent().remove()
    $('#header-search').empty()
    $('.header-banner').remove()
    $('#header nav').remove()
    me = Auth.me()
    headerCache = ModelCache

    if Browser.isEmbeddedDocument()
      if @onAnyBoardView()
        # We won't show the header if the board is embedded.
        $('#header').hide()
      else
        # We only need the logo if Trello is embedded.
        $('#header').empty().prepend templates.fill('header_logo')
        $('#header').show()
      return

    $('#header').empty().prepend templates.fill('header_logo')

    if opts.promo || !Auth.isLoggedIn()
      $('#header').append(templates.fill('header_promo_nav'))
    else

      $('#header').append(@topLevelView(HeaderBackButtonView, me, modelCache: headerCache).render().el)
      $('#header').append(@topLevelView(HeaderBoardsButtonView, me, modelCache: headerCache).render().el)
      if !opts.noSearch then $('#header').append(@topLevelView(SearchInputView, me, modelCache: headerCache).render().el)
      $('#header .header-woof').parent().remove()
      $('#header').append(@topLevelView(HeaderWoofView, me, modelCache: headerCache).render().el)

      renderBoardsDrawer = =>
        if !@_boardDrawerRendered
          @_boardDrawerRendered = true
          $('#boards-drawer')
          .empty()
          .append(new BoardsSidebarView({ model: me, modelCache: headerCache }).render().el)

      if SidebarState.getPinSidebar()
        renderBoardsDrawer()
      else
        # If the user doesn't have the sidebar pinned open, we can defer rendering it
        PostRender.enqueue 'render_boards_drawer', renderBoardsDrawer

    $('#header').append(@topLevelView(HeaderMemberView, me, { modelCache: headerCache, currentModel: @currentModel.get() }).render(opts.promo).el)

    bannerLocales =
    _.chain(locales)
      .pluck('code')
      .filter((locale) -> locale.indexOf('en') != 0)
      .value()

    # See if we need to display a "your browser is old" message
    if /^(explorer-10|safari-[678])/.test(Browser.browserVersionStr)
      track("Unsupported Browser Banner", "Displayed", Browser.browserVersionStr)
      $('#header').after(@topLevelView(BrowserWillBeUnsupportedView, me, modelCache: headerCache).render().el)

    # See if there are any important messages we'd like to convey to the user
    if @currentModel.get()? && Util.hasValidInviteTokenFor(@currentModel.get())
      opts = { modelCache: @getCurrentModelCache() }
      if @onAnyBoardView()
        opts.idBoard = @currentModel.get().id
      else if @onAnyOrganizationView()
        opts.idOrganization = @currentModel.get().id
      opts.idMemberAdder = Util.inviteTokenFor(@currentModel.get().id).split('-')[1]
      opts.isPersonalizedInvite = getExperiment('personalizedInvite', opts.idMemberAdder).get('enabled')
      $('#header').after(@topLevelView(InvitedBannerView, me, opts, @currentModel.get().id).render().el)
        .toggleClass('personalized-invite', opts.isPersonalizedInvite && !Auth.isLoggedIn())
    else
      if Auth.isLoggedIn()
        if !Auth.confirmed()
          $('#header').after(@topLevelView(ConfirmEmailBannerView, me, modelCache: headerCache).render().el)
        else if !Auth.canLogIn()
          $('#header').after(@topLevelView(SetPasswordBannerView, me, modelCache: headerCache).render().el)
        else if (enterprise = Auth.me().enterpriseWithRequiredConversion())? ||
                Auth.me().missedTransferDate()
          opts =
            modelCache: headerCache
            locale: locale
            enterprise: enterprise
          $('#header').after(@topLevelView(AccountTransferRequiredBannerView, me, opts).render().el)
        else if (org = getOverdueOrganization(Auth.me()))
          $('#header').after(@topLevelView(OverdueBannerView, org, modelCache: headerCache).render().el)
        else if needBackupCodes(Auth.me())
          $('#header').after(@topLevelView(TwoFactorBackupsBannerView, me, modelCache: headerCache).render().el)
        else if (locale = _.find(bannerLocales, (locale) -> Auth.me().shouldShowNewLanguageBannerFor(locale)))
          $('#header').after(@topLevelView(NewLocaleBannerView, me, { modelCache: headerCache, locale: locale }).render().el)

        # always try to add the seat cap banner, even if another banner is showing
        showSeatCapBanner(Auth.me(), headerCache, @topLevelView.bind(@))
      else
        if @onAnyBoardView() && @currentModel.get().isPublic()
          $('#header').after(@topLevelView(PublicBoardBannerView, @currentModel.get(), modelCache: @getCurrentModelCache()).render().el)

    me.checkColorBlindMode()
    return



// WEBPACK FOOTER //
// ./app/scripts/controller/header.coffee